var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4 10H16","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 14L16 10L12 6","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowRightInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","color":"currentColor","fill":"none"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
